
export const errorMess = {
  "1001": "not login",
}

export const NotLoginCode = 1001;

export const ApiIsLoginError = (error) => {
  if (error instanceof Map) {
    // eslint-disable-next-line no-irregular-whitespace
    // トークン有効性判断　U000053 U000054 U000055 U000072 U000045存在チェック
    if (error.has("U000053") ||
      error.has("U000054") ||
      error.has("U000055") ||
      error.has("U000072") ||
      error.has("U000045")) {
      return true
    }
  }

  return false
}

class ApiError extends Error {

  ErrorCode = 0;

  constructor(message) {
    super(message);
    this.name = "Api";
  }
}

export default ApiError;

// ----------------------------------------------------------------------
// API エラーの正規化
//
// cms-axios.js のインターセプタは HTTP 400 のとき response.data をそのまま reject する。
// つまり catch に来る値は Error とは限らず、形も一定しない:
//   {status:'USER_ERROR', error:{Name:'...', ItemName:'...'}}  バリデーションのフィールドマップ
//   {status:'USER_ERROR', error:'...'}                          文字列
//   {status:'USER_ERROR', error:{U000033:{...}}}                入れ子
//   Error('...')                                                httpGet/httpPost が status!=='OK' で投げる分
//   '...'                                                       素の文字列
//
// `error?.message` だけを見ると 400 系は必ず undefined になり、どの画面も
// 「保存に失敗しました」しか出せない。サーバーがどのフィールドが悪いか言っているのに捨てている。

/**
 * USER_ERROR のフィールドエラーを表示できる文字列の配列にする。
 * インラインで一覧表示したいとき（<Alert> を並べる等）に使う。
 *
 * @param {*} error reject された値
 * @returns {string[]} USER_ERROR 以外や中身が無ければ空配列
 */
export function normalizeApiErrors(error) {
    if (!error || error.status !== 'USER_ERROR') return [];

    const detail = error.error;
    if (!detail) return [];

    if (typeof detail === 'string') return [detail];

    if (Array.isArray(detail)) {
        return detail.map((v) => (typeof v === 'string' ? v : JSON.stringify(v)));
    }

    if (typeof detail === 'object') {
        return Object.keys(detail).map((key) => {
            const val = detail[key];
            if (typeof val === 'string') return val;
            return `${key}: ${JSON.stringify(val)}`;
        });
    }

    return [String(detail)];
}

/**
 * スナックバー 1 行に出すためのメッセージを返す。
 * USER_ERROR ならサーバーが返した内容を出し、それ以外は Error.message、
 * どれでもなければ呼び出し側の既定文言に落とす。
 *
 * @param {*} error reject された値
 * @param {string} fallback 既定の文言（例 '保存に失敗しました'）
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback) {
    const messages = normalizeApiErrors(error);
    if (messages.length > 0) return messages.join(' / ');

    if (typeof error === 'string' && error) return error;
    if (error?.message) return error.message;

    return fallback;
}
